import { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { ButtonBase, Popover, Stack } from "@mui/material"
import { AuthContext } from "../../controllers/auth"
import Center from "../../components/global/Center"
import Text from "../../components/global/Text"
import Button from "../../components/global/Button"
import Title from "../../components/global/Title"
import { colors } from "../../services/config/colors"
import { defaultTransition } from "../../services/config/constants"
import chevronDownPrimaryIcon from "../../assets/icons/chevron-down-primary.svg"
import "../../styles/select.css"
import PlatformLogo from "../../components/global/PlatformLogo"

const NotEnoughUsers = () => {
  const { t } = useTranslation()
  const { logOut, teamsList, team, setTeam, setViewNotEnoughUsersPage } =
    useContext(AuthContext)

  // team select popover
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const popoverOpen = Boolean(anchorEl)

  return (
    <Center>
      <PlatformLogo
        containerStyle={{ width: "fit-content" }}
        textStyle={{ maxWidth: 200 }}
      />
      <Title fontSize={26} fontWeight={900} style={{ marginTop: 42 }}>
        {team?.title}
      </Title>
      <Text textAlign="center" style={{ marginTop: 8 }}>
        {t("not_enough_users")}
      </Text>
      {teamsList.length > 1 && (
        <>
          <ButtonBase
            disableRipple
            style={{
              marginTop: 24,
              transition: defaultTransition,
            }}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <Stack direction="row" gap={1} style={{ height: 20 }}>
              <Title fontSize={14} color={colors.primary}>
                {t("change_team")}
              </Title>
              <img
                src={chevronDownPrimaryIcon}
                style={{
                  width: 12,
                  transform: popoverOpen ? "rotate(180deg)" : "none",
                  transition: "150ms",
                }}
                alt=""
              />
            </Stack>
          </ButtonBase>
          <Popover
            open={popoverOpen}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            classes={{ paper: "popover-paper" }}
          >
            <Stack style={{ width: 250 }}>
              {teamsList.map((option) => (
                <ButtonBase
                  key={option.id}
                  className={team && team.id === option.id ? "" : "select-item"}
                  style={{
                    width: "100%",
                    height: 49,
                    paddingLeft: 16,
                    justifyContent: "flex-start",
                    backgroundColor:
                      team && team.id === option.id
                        ? colors.backgroundLight
                        : colors.backgroundWhite,
                    transition: defaultTransition,
                  }}
                  onClick={() => {
                    setTeam(option)
                    localStorage.setItem("teamId", option.id)
                    setAnchorEl(null)
                    if (
                      !option.dashboardMinMembers ||
                      option.userCount >= option.dashboardMinMembers
                    ) {
                      setViewNotEnoughUsersPage(false)
                    }
                  }}
                  aria-label={option.title}
                >
                  <Stack direction="row" alignItems="center" gap={2}>
                    <img
                      src={option.logo}
                      style={{
                        width: 22,
                        minWidth: 22,
                        height: 22,
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "100%",
                      }}
                      alt=""
                    />
                    <Title
                      fontSize={14}
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {option.title}
                    </Title>
                  </Stack>
                </ButtonBase>
              ))}
            </Stack>
          </Popover>
        </>
      )}
      <Button onClick={logOut} style={{ width: 100, marginTop: 24 }}>
        {t("logout")}
      </Button>
    </Center>
  )
}

export default NotEnoughUsers
